import screenfull from 'screenfull'

function isSafari () {
  return screenfull.isFullscreen === undefined
}

export default isSafari
